export const INCREASE_STEP = 'INCREASE_STEP';
export const increaseStep = () => {
  return {
    type: INCREASE_STEP,
  };
};

export const DECREASE_STEP = 'DECREASE_STEP';
export const decreaseStep = () => {
  return {
    type: DECREASE_STEP,
  };
};

export const SET_STEP = 'SET_STEP';
export const setStep = (jumpStep) =>{
  return {
    type: SET_STEP,
    jumpStep,
  }
}